import { CreateNoteDocumentState } from '@/domains/notes/store/types/createNoteDocumentSliceTypes';

const initialCreateDocumentSteps = {
  documentType: null,
  documentEntity: {
    type: null,
    id: null,
  },
  documentUpload: null,
};

export const createDocumentInitialState: CreateNoteDocumentState = {
  createDocumentSteps: initialCreateDocumentSteps,
  statuses: {
    isCreateDocumentLoading: false,
    isOptionsLoading: false,
  },
  claimOptions: [],
  claimantOptions: [],
};
